import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { SharedService } from '../../services/shared.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-dropdown-checkbox-selection',
  templateUrl: './dropdown-checkbox-selection.component.html',
  styleUrls: ['./dropdown-checkbox-selection.component.scss']
})
export class DropdownCheckboxSelectionComponent {

  @Input() dropDownOption: any | null = [];
  @Input() showInvalueText: boolean = true;
  @Input() json_data: boolean = false;
  @Input() chooseOptions = '';
  @Input() search = false;
  @Input() unit = false;
  @Input() selected_item:any[] = [];
  @Output() dropDownValue: EventEmitter<any> = new EventEmitter();

  languageSub$: Subscription = new Subscription();
  langName = 'en';
  selectedItem: any = [];
  filteredOptions:any = [];
  selectedOptions:any = [];
  
  searchText: string = '';

  constructor(private shareService:SharedService){
   this.languageSub$ = this.shareService.language$.subscribe(lang => {
      this.langName = lang;
      this.selectedVal(this.selected_item);  
    })
  }

  filterOptions() {
    const search = this.searchText.toLowerCase();
    if (!search) {
      this.filteredOptions = this.dropDownOption;
    } else {
      this.filteredOptions = this.json_data ? this.dropDownOption.filter((opt:any) =>
        opt.label[this.shareService.getCurrentLangID()].toLowerCase().includes(search)
      )
      : this.dropDownOption.filter((opt:any) =>
        opt.toLowerCase().includes(search)
      );
    }
  }
  
  ngOnChanges(changes: SimpleChanges) {
    this.selectedItem = this.selected_item;
    this.filterOptions();
    this.selectedVal(this.selected_item);  
  }

  ngOnInit(): void{
    this.filteredOptions = this.dropDownOption;
    
  }

  selectedVal(selected_item?: any) {
    this.selectedOptions = this.json_data
      ? this.unit 
      ? this.filteredOptions
          .filter((item: any) => selected_item.includes(item.label[1]))
          .map((item: any) => item.label[this.shareService.getCurrentLangID()])
          : this.filteredOptions
          .filter((item: any) => selected_item.includes(item.name))
          .map((item: any) => item.label[this.shareService.getCurrentLangID()])
      : selected_item;
     
      
  }
  toggleResidentialType(event: any, key: string, menuTrigger: MatMenuTrigger) {
   
    if (event.checked) {
      if (!this.selectedItem.includes(key)) {
        this.selectedItem = [...this.selectedItem, key];
      }
    } else {
      if (this.selectedItem.length === 1) {
        event.source.checked = true; // revert checkbox visually
        return;
      }
      this.selectedItem = this.selectedItem.filter((e: any) => e !== key);
    }
    
    
    // menuTrigger.closeMenu();
  }


  onMenuClosed(){
    this.searchText='';
    this.filterOptions();
    if(!this.arraysHaveSameItems(this.selectedItem, this.selected_item)){
      this.selectedVal(this.selectedItem);
      this.dropDownValue.emit(this.selectedItem)
    }
  }


  arraysHaveSameItems(arr1: string[], arr2: string[]): boolean {
    if (arr1.length !== arr2.length) return false;

    const sortedA = [...arr1].sort();
    const sortedB = [...arr2].sort();

    return sortedA.every((item, index) => item === sortedB[index]);
  }

}
